export default {
    initialLists: state => {
        return Object.keys(state.expressCompanies);
    },
    initDate: state => {
        return state.pickupInit && state.pickupInit.businessHours ? Object.keys(state.pickupInit.businessHours) : [];
    },
    curDate: (state, getters) =>{
        return getters.initDate[0];
    }
}


// WEBPACK FOOTER //
// ./src/store/my-order/getters.js